import React from 'react';

const OpenLate = ({ color = 'var(--color-primary)' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      fill={color}
      fillRule="evenodd"
      stroke={color}
      strokeLinejoin="round"
      strokeWidth=".4"
      d="M6.839 2.525c-.056.422-.093.863-.093 1.285 0 5.584 4.592 10.121 10.246 10.121h.335c-1.432 2.48-4.128 4.06-7.103 4.06-4.52 0-8.201-3.637-8.201-8.1 0-3.197 1.952-6.063 4.816-7.366h0zM1 9.889C1 14.922 5.128 19 10.223 19c4.091 0 7.568-2.645 8.777-6.3-.65.147-1.32.22-2.008.22-5.095 0-9.224-4.077-9.224-9.11 0-.973.168-1.928.447-2.81C4.086 1.9 1 5.537 1 9.89z"
    />
  </svg>
);

export default OpenLate;
